import { css } from 'styled-components';
import { techColors } from './TechRetroEffects';

// Общие паттерны фона для всех страниц
// Minimal monochrome — чёрно-белый tech без цветных акцентов

const techSurfaceGradient = `
  linear-gradient(
    165deg,
    ${techColors.darkBg} 0%,
    ${techColors.darkBgMid} 45%,
    ${techColors.darkBgSecondary} 100%
  )
`;

// Sidebar — темнее основной области чата
export const sidebarSurface = css`
  background: ${techColors.darkBg};
`;

// Панель чата
export const panelSurface = css`
  background: ${techColors.darkBgSecondary};
`;

// Область сообщений — чуть темнее для лёгкого контраста
export const messageSurface = css`
  background: ${techColors.darkBg};
`;

// Основной фон приложения — плоский чёрный без углового свечения
export const abstractBackgroundMinimalTech = css`
  background: ${techColors.darkBg};
  position: relative;
`;

// ВАРИАНТ 1: Сетка с радиальными градиентами
export const abstractBackground = css`
  background: ${techSurfaceGradient};
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.06) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.06) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.05) 0%, transparent 70%),
    linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
    linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 100% 100%, 100% 100%, 100% 100%, 20px 20px, 20px 20px;
  position: relative;
`;

// ВАРИАНТ 2: Точечный паттерн (Dot Matrix)
export const abstractBackgroundDotMatrix = css`
  background: ${techSurfaceGradient};
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.08) 0%, transparent 50%),
    radial-gradient(circle, rgba(255, 255, 255, 0.15) 1px, transparent 1px);
  background-size: 100% 100%, 100% 100%, 15px 15px;
  position: relative;
`;

// ВАРИАНТ 3: Circuit Board (печатная плата) - более яркая сетка
export const abstractBackgroundCircuit = css`
  background: ${techSurfaceGradient};
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    linear-gradient(90deg, rgba(255, 255, 255, 0.15) 1px, transparent 1px),
    linear-gradient(rgba(255, 255, 255, 0.15) 1px, transparent 1px),
    radial-gradient(circle, rgba(255, 255, 255, 0.2) 1px, transparent 1px);
  background-size: 100% 100%, 100% 100%, 25px 25px, 25px 25px, 25px 25px;
  position: relative;
`;

// ВАРИАНТ 4: Минималистичный - только радиальные градиенты
export const abstractBackgroundMinimal = css`
  background: ${techSurfaceGradient};
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.08) 0%, transparent 60%),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.08) 0%, transparent 60%),
    radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.06) 0%, transparent 80%);
  background-size: 100% 100%, 100% 100%, 100% 100%;
  position: relative;
`;

// ВАРИАНТ 5: Гексагональная сетка (Hex Grid)
export const abstractBackgroundHex = css`
  background: ${techSurfaceGradient};
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.06) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.06) 0%, transparent 50%),
    repeating-linear-gradient(
      60deg,
      transparent,
      transparent 20px,
      rgba(255, 255, 255, 0.08) 20px,
      rgba(255, 255, 255, 0.08) 21px,
      transparent 21px,
      transparent 40px
    ),
    repeating-linear-gradient(
      -60deg,
      transparent,
      transparent 20px,
      rgba(255, 255, 255, 0.06) 20px,
      rgba(255, 255, 255, 0.06) 21px,
      transparent 21px,
      transparent 40px
    );
  background-size: 100% 100%, 100% 100%, 40px 40px, 40px 40px;
  position: relative;
`;

// ВАРИАНТ 6: Более контрастный с яркими акцентами
export const abstractBackgroundContrast = css`
  background: ${techSurfaceGradient};
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.12) 0%, transparent 50%),
    linear-gradient(90deg, rgba(255, 255, 255, 0.2) 1px, transparent 1px),
    linear-gradient(rgba(255, 255, 255, 0.2) 1px, transparent 1px);
  background-size: 100% 100%, 100% 100%, 18px 18px, 18px 18px;
  position: relative;
`;

// ВАРИАНТ 7: Светлый фон с темными акцентами
export const abstractBackgroundLight = css`
  background: linear-gradient(135deg, #e8e8e8 0%, #f5f5f5 25%, #f0f0f0 50%, #f5f5f5 75%, #e8e8e8 100%);
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),
    radial-gradient(circle, rgba(255, 255, 255, 0.2) 1px, transparent 1px);
  background-size: 100% 100%, 100% 100%, 15px 15px;
  position: relative;
`;

// ВАРИАНТ 8: Светлый фон с сеткой
export const abstractBackgroundLightGrid = css`
  background: linear-gradient(135deg, #e8e8e8 0%, #f5f5f5 25%, #f0f0f0 50%, #f5f5f5 75%, #e8e8e8 100%);
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.12) 0%, transparent 50%),
    linear-gradient(90deg, rgba(255, 255, 255, 0.25) 1px, transparent 1px),
    linear-gradient(rgba(255, 255, 255, 0.25) 1px, transparent 1px);
  background-size: 100% 100%, 100% 100%, 20px 20px, 20px 20px;
  position: relative;
`;

// ВАРИАНТ 9: Белый/очень светлый фон
export const abstractBackgroundWhite = css`
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 25%, #f8f8f8 50%, #fafafa 75%, #ffffff 100%);
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.2) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.2) 0%, transparent 50%),
    radial-gradient(circle, rgba(255, 255, 255, 0.3) 1px, transparent 1px);
  background-size: 100% 100%, 100% 100%, 15px 15px;
  position: relative;
`;

// ВАРИАНТ 10: Мягкий — без сетки, для auth-страниц
export const abstractBackgroundSoft = css`
  ${abstractBackgroundMinimalTech}
`;

// ВАРИАНТ 12: Плавный градиент — alias для minimal tech
export const abstractBackgroundSmooth = css`
  ${abstractBackgroundMinimalTech}
`;

export const abstractBackgroundBefore = css`
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      repeating-linear-gradient(
        45deg,
        transparent,
        transparent 15px,
        rgba(255, 255, 255, 0.03) 15px,
        rgba(255, 255, 255, 0.03) 16px,
        transparent 16px,
        transparent 30px
      ),
      repeating-linear-gradient(
        -45deg,
        transparent,
        transparent 15px,
        rgba(255, 255, 255, 0.02) 15px,
        rgba(255, 255, 255, 0.02) 16px,
        transparent 16px,
        transparent 30px
      ),
      radial-gradient(ellipse at 30% 20%, rgba(255, 255, 255, 0.04) 0%, transparent 25%),
      radial-gradient(ellipse at 70% 80%, rgba(255, 255, 255, 0.03) 0%, transparent 25%);
    background-size: 30px 30px, 30px 30px, 250px 180px, 250px 180px;
    background-position: 0 0, 0 0, 0 0, 100% 100%;
    opacity: 0.6;
    pointer-events: none;
  }
`;

